import { CASE_STUDIES } from "../../data/content";
import { Reveal } from "../MaskedLine";

const GROUNDS = ["ground-paper", "ground-lab", "ground-margin"];

export default function SelectedWork() {
  return (
    <section data-testid="selected-work-section" className="ground-paper sec-pad border-t border-[color:var(--line-soft)]">
      <div className="wrap">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-10">
          <div>
            <p className="stamp mb-4" style={{ fontSize: 12 }}>Selected work</p>
            <h2 className="h-section" style={{ fontSize: "clamp(28px, 3.4vw, 46px)", lineHeight: 1.08 }}>
              Selected capability builds.
            </h2>
          </div>
          <p className="font-body-serif measure-narrow text-[#383D5A]" style={{ fontSize: 17 }}>
            A look at the workplace problems, capability focus and learning design behind selected engagements.
          </p>
        </div>

        <div className="border-t-[1.5px] border-[color:var(--ink)] grid grid-cols-1 lg:grid-cols-3">
          {CASE_STUDIES.map((c, i) => (
            <Reveal key={c.slug} delay={i * 0.06}>
              <article
                data-testid={`case-study-${c.slug}`}
                className={`${GROUNDS[i % GROUNDS.length]} p-8 md:p-10 h-full border-b-[1.5px] border-[color:var(--ink)] lg:border-b-0 ${i > 0 ? "lg:border-l-[1.5px] lg:border-[color:var(--ink)]" : ""}`}
              >
                <span className="stamp" style={{ fontSize: 12 }}>{c.sector}</span>
                <h3 className="font-hook mt-6 measure-narrow" style={{ fontSize: "clamp(22px, 2.2vw, 28px)", lineHeight: 1.12, letterSpacing: "-0.015em" }}>
                  {c.title}
                </h3>

                <dl className="mt-8 space-y-6">
                  <div>
                    <dt className="stamp-dim" style={{ fontSize: 11 }}>Challenge</dt>
                    <dd className="font-body-serif mt-2" style={{ fontSize: 15.5, lineHeight: 1.6 }}>{c.challenge}</dd>
                  </div>
                  <div>
                    <dt className="stamp-dim" style={{ fontSize: 11 }}>Capability focus</dt>
                    <dd className="font-body-serif mt-2" style={{ fontSize: 15.5, lineHeight: 1.6 }}>{c.focus}</dd>
                  </div>
                  <div>
                    <dt className="stamp-dim" style={{ fontSize: 11 }}>Intervention design</dt>
                    <dd className="font-body-serif mt-2" style={{ fontSize: 15.5, lineHeight: 1.6 }}>{c.intervention}</dd>
                  </div>
                </dl>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
